// MainRoutes.tsx
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { router_config } from '../configs/route.config'

import GuestRoute from './components/guestRoute'
import UserRoute from './components/userRoute'
import ChildRoute from './components/childRoute'

// Page Imports
import Home from '../pages/Home/Index'
import AboutKied from '../pages/AboutUs/AboutKied'
import ContactUs from '../pages/AboutUs/ContactUs'
import Dashboard from '../pages/Dashboard/Dashboard'
import Careers from '../pages/Information/Careers'
import Internships from '../pages/Information/Internships'
import TrainingCalendar from '../pages/Initiatives/TraningCalender'
import UpcomingEventsPage from '../pages/Initiatives/UpcommingEvents'
import PublicationsAndNewsletters from '../pages/Resources/Publications and Newsletters'
import Materials from '../pages/Resources/Materials'
import Schemes from '../pages/Resources/Schemes'
import Facilitation from '../pages/Departments2/Facilitation'
import TechnologyTransfer from '../pages/Departments2/TechnologyTransfer'
import IndustryAcademyCollaboration from '../pages/Departments2/IndustryAcademyCollaboration'
import AnnualReports from '../pages/Resources/Annul_Reports/Index'
import LearningDepartment from '../pages/Departments/learning'
import InternshipForm from '../pages/Information/Internships/internship-form'
import Incubation from '../pages/Departments/Incubation'

import TechHorizons from '../pages/Departments2/Program-details'
import GrievanceRedressal from '../pages/Information/Redressal'
import IndustryAcademyCollaborationForm from '../pages/Departments2/IndustryAcademyCollaboration/Form'
import Registration from '../pages/Registration'
import AdminLogin from '../pages/Login'
// import OurTeam from '../pages/AboutUs/OurTeam'
import OurMembers from '../pages/AboutUs/CouncilMembers'
import Rti from '../pages/Information/RTI'
import ActsAndRules from '../pages/Information/ActsAndRules'
import VerifyEmail from '../pages/VerifyEmail'
import InitialView from '../pages/Departments/Incubation/Incubation-form/InitialView'
import FacilitationFormMain from '../pages/Departments2/Facilitation/Form'
import DashboardLayout from '../layout/DashboardLayout'
// import Overview from '../pages/Dashboard/Overview'
import Reports from '../pages/Dashboard/Reports'
import Settings from '../pages/Dashboard/Settings'
import Certificate from '../pages/Dashboard/Certificate'
import EDCRegistration from '../pages/Departments/learning/Form/Create'
import PrimaryView from '../pages/Initiatives/Event-form/PrimaryView'
import ProfilePage from '../pages/Profile/ProfileDetails'
import ResetPassword from '../pages/ResetPassword'
import Tenders from '../pages/Information/tenders'
import EventDetails from '../pages/Initiatives/EventsDetail'
import TermsAndConditions from '../pages/TermsAndCondition'
import YouTubeVideos from '../pages/Resources/Media/Videos'
import Gallery from '../pages/Resources/Media/Gallery/GallerySection'
import EDCPage from '../pages/Initiatives/EDC'
import Nbfc from '../pages/Initiatives/Nbfc'

// Route definitions
const app_routes = [
  { slug: 'HOME', component: <Home />, isAuthRoute: true },
  { slug: 'AUTH_HOME', component: <Home /> },

  { slug: 'ABOUT_KIED', component: <AboutKied />, isGuestRoute: true },
  { slug: 'OUR_MEMBERS', component: <OurMembers />, isGuestRoute: true },
  // { slug: 'OUR_TEAM', component: <OurTeam />, isGuestRoute: true },
  { slug: 'INTERNSHIPS', component: <Internships />, isGuestRoute: true },
  { slug: 'CONTACT_US', component: <ContactUs />, isGuestRoute: true },
  { slug: 'CAREERS', component: <Careers />, isGuestRoute: true },
  { slug: 'RTI', component: <Rti />, isGuestRoute: true },
  {
    slug: 'ACTS_RULES_GOVERNMENT_ORDERS',
    component: <ActsAndRules />,
    isGuestRoute: true,
  },

  {
    slug: 'TRAININGCALENDAR',
    component: <TrainingCalendar />,
    isGuestRoute: true,
  },
  { slug: 'EDC', component: <EDCPage />, isGuestRoute: true },
  {
    slug: 'UPCOMMINGEVENTS',
    component: <UpcomingEventsPage />,
    isGuestRoute: true,
  },
  { slug: 'DASHBOARD', component: <Dashboard />, isAuthRoute: true },
  {
    slug: 'PUBLICATIONS_AND_NEWSLETTERS',
    component: <PublicationsAndNewsletters />,
    isGuestRoute: true,
  },
  { slug: 'MATERIALS', component: <Materials />, isGuestRoute: true },
  { slug: 'SCHEMES', component: <Schemes />, isGuestRoute: true },
  { slug: 'FACILITATION', component: <Facilitation />, isGuestRoute: true },
  {
    slug: 'FACILITATION_FORM',
    component: <FacilitationFormMain />,
    isGuestRoute: true,
  },
  {
    slug: 'TECHNOLOGY_TRANSFER',
    component: <TechnologyTransfer />,
    isGuestRoute: true,
  },
  {
    slug: 'INDUSTRY_ACADEMY_COLLABORATION',
    component: <IndustryAcademyCollaboration />,
    isGuestRoute: true,
  },
  { slug: 'TECH_HORIZON', component: <TechHorizons />, isGuestRoute: true },
  { slug: 'ANNUALREPORTS', component: <AnnualReports />, isGuestRoute: true },
  { slug: 'LEARNING', component: <LearningDepartment /> },
  { slug: 'INTERNSHIPFORM', component: <InternshipForm />, isGuestRoute: true },
  { slug: 'INCUBATION', component: <Incubation />, isGuestRoute: true },
  {
    slug: 'INCUBATION_FORM',
    component: <InitialView />,
    isGuestRoute: true,
  },
  { slug: 'INCUBATION_VIEW', component: <InitialView />, isGuestRoute: true },
  { slug: 'REDRESSAL', component: <GrievanceRedressal /> },
  {
    slug: 'ACADEMIC_FORM',
    component: <IndustryAcademyCollaborationForm />,
    isGuestRoute: true,
  },
  { slug: 'GALLERY_VIDEO', component: <YouTubeVideos />, isGuestRoute: true },
  { slug: 'GALLERY_PHOTO', component: <Gallery />, isGuestRoute: true },
  { slug: 'LOGIN', component: <AdminLogin />, isAuthRoute: true },
  { slug: 'REGISTRATION', component: <Registration />, isAuthRoute: true },
  { slug: 'VERIFYEMAIL', component: <VerifyEmail />, isAuthRoute: true },
  { slug: 'RESETPASSWORD', component: <ResetPassword />, isGuestRoute: true },
  {
    slug: 'TERMSANDCONDITION',
    component: <TermsAndConditions />,
    isGuestRoute: true,
  },
  {
    slug: 'DYNAMIC_FORM',
    component: <EDCRegistration />,
    isGuestRoute: true,
  },
  {
    slug: 'NBFC',
    component: <Nbfc />,
    isGuestRoute: true,
  },
  {
    slug: 'UPCOMMINGEVENTS_FORM',
    component: <PrimaryView />,
    isGuestRoute: true,
  },
  {
    slug: 'UPCOMMINGEVENTS_DETAIL',
    component: <EventDetails />,
    isGuestRoute: true,
  },

  // PROFILE_DETAILS moved to dashboard nested routes
  // {
  //   slug: 'PROFILE_DETAILS',
  //   component: <ProfilePage />,
  //   isGuestRoute: true,
  // },
  {
    slug: 'TENDERS',
    component: <Tenders />,
    isGuestRoute: true,
  },
]

export default function MainRoutes() {
  return (
    <Routes>
      {app_routes.map((route: any) => (
        <>
          {route.isAuthRoute ? (
            <Route
              element={<GuestRoute>{route.component}</GuestRoute>}
              path={router_config[route.slug].path}
              key={router_config[route.slug].path}
            />
          ) : (
            <Route
              element={
                <UserRoute
                  slug_key={route.slug}
                  hasChild={
                    route?.isPrimary ? false : Boolean(route?.children?.length)
                  }
                >
                  {route.component}
                </UserRoute>
              }
              path={router_config[route.slug].path}
              key={router_config[route.slug].path}
            >
              {route.children?.length && (
                <>
                  {route.children.map((child: any) => (
                    <Route
                      element={
                        <ChildRoute slug_key={child.slug}>
                          {child.component}
                        </ChildRoute>
                      }
                      path={router_config[child.slug].path}
                      key={router_config[child.slug].path}
                    />
                  ))}
                </>
              )}
            </Route>
          )}
        </>
      ))}

      <Route
        path={router_config['DASHBOARD'].path}
        element={
          <UserRoute slug_key="DASHBOARD">
            <DashboardLayout />
          </UserRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="incubation" element={<Dashboard />} />
        <Route path="programs" element={<Dashboard />} />
        <Route path="facilitations" element={<Dashboard />} />
        <Route path="upcoming-programs" element={<Dashboard />} />
        <Route
          path={router_config['DASHBOARD_CERTIFICATE'].path?.replace(
            '/dashboard/',
            ''
          )}
          element={<Certificate />}
        />
        {/* <Route
          path={router_config['DASHBOARD_OVERVIEW'].path?.replace(
            '/dashboard/',
            ''
          )}
          // element={<Overview />}
        /> */}
        <Route
          path={router_config['DASHBOARD_REPORTS'].path?.replace(
            '/dashboard/',
            ''
          )}
          element={<Reports />}
        />
        <Route
          path={router_config['DASHBOARD_SETTINGS'].path?.replace(
            '/dashboard/',
            ''
          )}
          element={<Settings />}
        />
        <Route path="profile-details" element={<ProfilePage />} />
      </Route>
    </Routes>
  )
}
